module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "dealerModal"
    }
  }, [_c('row', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('column', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": _vm.title,
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Dealer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Dealer Name"
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "align": "center"
    }
  }, [_c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n                ")])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Save",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-3"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ee3e8c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddDealer.vue
// module id = 687
// module chunks = 0